import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, formData);
      localStorage.setItem('admin_token', response.data.access_token);
      localStorage.setItem('admin_user', JSON.stringify(response.data.user));
      toast.success('Login successful!');
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Invalid credentials');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#001a2e] via-[#00457f] to-[#003461] flex items-center justify-center p-4 sm:px-6 lg:px-8">
      <Card className="w-full max-w-md border-2 border-white/20 shadow-2xl">
        <CardHeader className="text-center space-y-2 pb-6 px-4 sm:px-6">
          <img
            src="/assets/images/wnc-logo.png"
            alt="World Nuclear Congress"
            className="h-16 sm:h-20 mx-auto mb-3 sm:mb-4"
          />
          <CardTitle className="text-2xl sm:text-3xl font-bold text-[#00457f]">
            Admin Login
          </CardTitle>
          <p className="text-sm sm:text-base text-gray-600">
            World Nuclear Congress
          </p>
        </CardHeader>
        <CardContent className="px-4 sm:px-6 pb-6">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="space-y-2">
              <Label htmlFor="username" className="text-sm sm:text-base font-semibold text-gray-700">
                Username
              </Label>
              <Input
                id="username"
                name="username"
                type="email"
                placeholder="admin@example.com"
                value={formData.username}
                onChange={handleInputChange}
                required
                className="h-11 sm:h-12 text-sm sm:text-base border-2 focus:border-[#00457f] transition-colors"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password" className="text-sm sm:text-base font-semibold text-gray-700">
                Password
              </Label>
              <Input
                id="password"
                name="password"
                type="password"
                placeholder="Enter your password"
                value={formData.password}
                onChange={handleInputChange}
                required
                className="h-11 sm:h-12 text-sm sm:text-base border-2 focus:border-[#00457f] transition-colors"
              />
            </div>

            <Button
              type="submit"
              disabled={isLoading}
              className="w-full bg-gradient-to-r from-yellow-500 via-amber-500 to-yellow-600 hover:from-yellow-600 hover:via-amber-600 hover:to-yellow-700 text-white font-bold text-base sm:text-lg py-5 sm:py-6 transition-all duration-300 transform hover:scale-105"
              style={{
                boxShadow: '0 10px 40px rgba(245, 158, 11, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.3)'
              }}
            >
              {isLoading ? 'Logging in...' : 'Login'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;